import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authenticatedFetch, useAuth } from './AuthComponent';

async function jsonOrThrow(resp) {
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) throw new Error(data.detail || `${resp.status} ${resp.statusText}`);
  return data;
}

const inputStyle = {
  width: '100%', boxSizing: 'border-box',
  padding: '8px 12px', border: '1px solid #c9cccf', borderRadius: 8,
  fontSize: 14, color: '#202223', outline: 'none',
};

function ForcedPasswordReset() {
  const { setMustResetPassword, logout } = useAuth();
  const navigate = useNavigate();
  const [tempPassword, setTempPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (newPassword !== confirmPassword) {
      setError("New password and confirmation don't match.");
      return;
    }
    setLoading(true);
    try {
      await authenticatedFetch('/api/users/me/change-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ current_password: tempPassword, new_password: newPassword }),
      }).then(jsonOrThrow);
      setMustResetPassword(false);
      navigate('/', { replace: true });
    } catch (e) {
      setError(e.message || String(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', backgroundColor: '#f6f6f7',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    }}>
      <div style={{
        width: '100%', maxWidth: 400, backgroundColor: '#ffffff', borderRadius: 12,
        boxShadow: '0 2px 8px rgba(0,0,0,0.08), 0 0 0 1px rgba(0,0,0,0.06)',
        padding: '28px 28px 24px', margin: '0 16px',
      }}>
        <h1 style={{ fontSize: 18, fontWeight: 700, color: '#202223', margin: '0 0 4px' }}>
          Set a new password
        </h1>
        <p style={{ color: '#6d7175', fontSize: 13.5, margin: '0 0 20px' }}>
          You're signed in with a temporary password. Set a permanent one to continue.
        </p>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 14 }}>
            <label style={{ display: 'block', marginBottom: 6, fontSize: 13, fontWeight: 550 }}>Temporary password</label>
            <input type="password" required autoComplete="current-password" value={tempPassword}
                   onChange={(e) => setTempPassword(e.target.value)} disabled={loading} style={inputStyle} />
          </div>
          <div style={{ marginBottom: 14 }}>
            <label style={{ display: 'block', marginBottom: 6, fontSize: 13, fontWeight: 550 }}>New password</label>
            <input type="password" required autoComplete="new-password" value={newPassword}
                   onChange={(e) => setNewPassword(e.target.value)} disabled={loading} style={inputStyle} />
            <p style={{ color: '#6d7175', fontSize: 12, margin: '4px 0 0' }}>At least 10 characters.</p>
          </div>
          <div style={{ marginBottom: 20 }}>
            <label style={{ display: 'block', marginBottom: 6, fontSize: 13, fontWeight: 550 }}>Confirm new password</label>
            <input type="password" required autoComplete="new-password" value={confirmPassword}
                   onChange={(e) => setConfirmPassword(e.target.value)} disabled={loading} style={inputStyle} />
          </div>
          {error && (
            <div style={{ marginBottom: 16, padding: '10px 12px', backgroundColor: '#fff4f4', border: '1px solid #ffd2d2', borderRadius: 8, color: '#d72c0d', fontSize: 13 }}>
              {error}
            </div>
          )}
          <button type="submit" disabled={loading} style={{
            width: '100%', padding: '9px 16px', backgroundColor: loading ? '#95c9b4' : '#008060',
            color: '#fff', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600,
            cursor: loading ? 'not-allowed' : 'pointer',
          }}>
            {loading ? 'Saving...' : 'Set password and continue'}
          </button>
        </form>
        <div style={{ textAlign: 'center', marginTop: 16 }}>
          <a href="/login" onClick={(e) => { e.preventDefault(); logout(); navigate('/login'); }}
             style={{ color: '#6d7175', fontSize: 13 }}>
            Sign out
          </a>
        </div>
      </div>
    </div>
  );
}

export default ForcedPasswordReset;
